

//********************************************
//Change the color of navigation based on scroll location
function navigationColor (){
  var slideShowHeight = $('#shopify-section-slideshow').height();
  $(window).on('scroll', function() {
    if($(this).scrollTop() > slideShowHeight) {
      $('header.site-header').addClass('site-header-bg');
      $(".header-wrapper.hero__header").addClass('forced');
    } else if (slideShowHeight > $(this).scrollTop()) {
      $('header.site-header').removeClass('site-header-bg');
      $(".header-wrapper.hero__header").removeClass('forced');
    }
  });
}


// Collaps product description on mobile
// function collapsDescription (){
//   if ($(window).width() < 500) {
//     $( ".template-product .product-single__description" ).slideUp();
//     $(".details-button").fadeIn();   
//   }
// }
// $(".details-button").on('click', function() {
//   $( ".template-product .product-single__description" ).slideDown();
//   $(".details-button").fadeOut();   
// });


/********************************************
swap grid image with variant image on hover function
********************************************/
function imageswap (){
  var variantArray = [];
  var loopIndex = 0;
  //loop through all variants, assign src temp, assign unique id based on index
  $( ".grid-product .variant_img" ).each(function() {
    var srcTest = $( this ).attr( "src" );
    var newSRC = $( this ).attr( "src" );
    var res = newSRC.replace("x80", "400x");
    $("#invisible-img-container").append('<img src=' + res + ' />');
    $(this).attr("id", "variant_img" + loopIndex);
    loopIndex += 1;
    variantArray.push($( this ).attr( "src" ));
  });
  //matching ending digits of id to variantArray
  $('.grid-product .variant_img').mouseover(function(){
    var endingDigits = $(this).attr("id").match(/\d+$/);
    var newSRC = variantArray[endingDigits];
    var res = newSRC.replace("x80", "400x");
    $(this).closest('.grid-product').find('.product--image').attr('srcset', res);
  })
} 



$(window).on('load', function() {

  navigationColor();
//   collapsDescription();
  imageswap();

  //turn into slider
  $('.bbc-slide').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
  });
  
    $('.product-slider').slick({
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 4,
    slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 6000,
      responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        speed: 700,
        slidesToScroll: 2,
        infinite: true,
        arrows: false,
        dots: true
      }
    }
  ]
  });


});